import {
  Grid,
  Box,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import { getContributorArca } from "../../services/ContributorArca";
import { useTheme } from "@mui/material/styles";
import AssignmentIcon from "@mui/icons-material/Assignment";
import GlassCard from "../General/GlassCard";
import { useToast } from "../../context/ToastContext";

export default function ManagerContributorArca() {
  const { showToast } = useToast();
  const [contributors, setContributors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState("");
  const [name, setName] = useState("");
  const theme = useTheme();
  const icon = <AssignmentIcon sx={{ fontSize: 32 }} />;
  const title = "Gestión de Personas ARCA";
  const description = "Buscar y gestionar personas en el sistema ARCA";

  const columns = [
    { field: "document", headerName: "CUIT", flex: 1 },
    { field: "name", headerName: "Nombre", flex: 4 },
    {
      field: "status",
      headerName: "Estado",
      flex: 1,
      renderCell: (params) => {
        if (params.value === "0") return "";
        if (params.value === "1" || params.value === 2) return "Fallecido";
        return params.value;
      },
    },
  ];

  const handleSearch = async () => { // limpiar error antes de nueva búsqueda

    // Validación: no permitir enviar vacío
    if (!document.trim() && !name.trim()) {
      showToast("Debe ingresar un Documento o un Nombre para buscar.", "error")
      return;
    }

    setLoading(true);
    try {
      const res = await getContributorArca({
        perPage: 50,
        document: document, // para no mandar string vacío
        name: name,
      });

      console.log(document, name);

      setContributors(
        res.data.data.map((item, index) => ({ ...item, id: index }))
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <GlassCard>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 3,
            }}
          >
            {icon && (
              <Box
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: "white",
                  borderRadius: "50%",
                  width: 64,
                  height: 64,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {icon}
              </Box>
            )}

            <Typography variant="h5" fontWeight="bold" align="center">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              {description}
            </Typography>
          </Box>
          {/* Formulario */}
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
              label="Documento"
              variant="outlined"
              type="number"
              placeholder="CUIT o Documento sin guiones"
              value={document}
              onChange={(e) => setDocument(e.target.value)}
              sx={{ flex: 1 }}
            />
            <TextField
              label="Nombre"
              placeholder="Nombre, Razón Social o Alias"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              sx={{ flex: 2 }}
            />
            <Button
              onClick={handleSearch}
              disabled={loading}
              variant="contained"
            >
              {loading ? <CircularProgress size={24} /> : "Buscar"}
            </Button>
          </Box>

          {/* DataGrid */}
          <Box sx={{ width: "100%", height: 600 }}>
            <DataGrid
              rows={contributors}
              columns={columns}
              autoHeight={false}
              disableColumnFilter
              disableSelectionOnClick
              hideFooterPagination
              loading={loading && contributors.length === 0}
              sx={{ flex: 1 }}
              showToolbar
            />
          </Box>
        </GlassCard>
      </Grid>
    </Grid>
  );
}
